import React from "react";

export default function GlassCard({ children, variant = "md", className = "", hoverable = false, ...props }) {
  const cls = {
    md: "glass-card",
    sm: "glass-card-sm",
    accent: "glass-card-accent",
    modal: "glass-modal",
  }[variant] || "glass-card";

  return (
    <div className={`${cls} ${hoverable ? "hoverable" : ""} ${className}`} {...props}>
      {children}
    </div>
  );
}
